module.exports = __webpack_public_path__ + "media/images/icon__profile@2x-0d95244ca9d52ab8b60abf092f97df96.png";